const Description = () => (
  <main className='mt-5 pt-5'>
    <div className='container'>
      <section id='best-features' className='text-center'>
        <h2 className='mb-3 font-weight-bold'>Our Home</h2>
        <i id='description' className='fa-solid fa-house fa-2xl pb-4'></i>
        <div className='row d-flex justify-content-center mb-4'>
          <div className='col-md-8'>
            <p className='grey-text pt-5'>
            Situated in the beautiful village of East Linton, Lynn Cottage is perfectly placed for exploring this fabulous area of coastal Scotland. The 2-bed cottage is 10 minutes' walk to the village centre and has stunning views from the back garden over Drylaw Hill.
            </p>
            <p className='grey-text'>
            Whether you are golfers, walkers, cyclists or looking for family fun you will find many attractions to keep you busy. Officially the sunniest area of Scotland, East Lothian has a lot to offer, from its spectacular coastline with fantastic beaches to historic castles, world-class golf courses and hill country. All within easy reach of Edinburgh with its numerous attractions.
            </p>
            <p className='grey-text'>
            Alternatively, if you are looking for total relaxation and rest, this is the perfect place to be, a cosy warm cottage which has 2 great pubs (with good food) within easy walking distance.
            </p>
          </div>
        </div>
      </section>
    </div>
  </main>
)

export default Description
